export const trackPageView = (url) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_path: url,
      page_location: window.location.href,
      page_title: document.title,
    });
    console.log('Page view');
  }
  else {
    console.log('No gtag: '+url);
  }
};